<script>
  import ModalSettings from "./components/ModalSettings.svelte";
  import GeneralSettings from "./components/GeneralSettings.svelte";
  import BellSettings from "./components/BellSettings.svelte";
  import Activation from "./components/Activation.svelte";
  import {SETTING_SAVE_TYPES} from "../constants"
  import { saveSettings } from "../api";

  let visibleTab = 0;

  const tabsList = [
    {
      id: 0,
      label: "Activation",
      comp: Activation,
      icon: "fa-user-check"
    },
    {
      id: 1,
      label: "General",
      comp: GeneralSettings,
      icon: "fa-border-all"
    },
    {
      id: 2,
      label: "Subscription Prompt",
      comp: ModalSettings,
      icon: "fa-window-maximize"
    },
    {
      id: 3,
      label: "Bell",
      comp: BellSettings,
      icon: "fa-bell"
    }
  ];
  const submitSettings = async (type, data) => {
    const validTypes = Object.values(SETTING_SAVE_TYPES);

    if (validTypes.indexOf(type) === -1) {
      throw new Error("invalid type for save options");
    }

    let formData = new FormData();
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        formData.append(key, data[key]);
      }
    }

    return saveSettings(type, formData);
  };
</script>

<style>
  a {
    text-decoration: none !important;
  }

  a:focus {
    box-shadow: none !important;
  }
  .tab-label {
    font-size: 0.87rem;
  }
</style>

<div class="container is-fluid">
  <div class="notification">
    <div class="tabs is-boxed">
      <ul>
        {#each tabsList as tab (tab.id)}
          <li
            on:click={() => (visibleTab = tab.id)}
            class:is-active={visibleTab === tab.id}>
            <a href="javascript:void(0);">
              <span class="icon is-small">
                <i class={`fas ${tab.icon}`} aria-hidden="true" />
              </span>
              <span class="tab-label">{tab.label}</span>
            </a>
          </li>
        {/each}
      </ul>
    </div>

    {#each tabsList as tab (tab.id)}
      <div class:is-hidden={visibleTab !== tab.id}>
        <svelte:component this={tab.comp} {submitSettings} />
      </div>
    {/each}
  </div>
</div>
